<div hidden>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>

<p-dialog
    header="Message"
    [(visible)]="this.showMsgDialog"
    [modal]="true"
    [style]="{ width: '50em' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="onHideMsgDialogSubject.next()"
>
    <div
        *ngIf="defaultRoleID == 1 && (!!adminMsg1 || !!adminLink1)"
        style="display: flex; flex-direction: column; padding: 1em"
    >
        <div [innerHTML]="adminMsg1 | safe: 'html'"></div>
        <a [href]="this.adminLink1" target="_blank">{{ adminLink1 }}</a>
    </div>
    <div
        *ngIf="
            (defaultRoleID == 1 || defaultRoleID == 12024) &&
            (!!mgrLink1 || !!mgrMsg1)
        "
        style="display: flex; flex-direction: column; padding: 1em"
    >
        <div [innerHTML]="mgrMsg1 | safe: 'html'"></div>
        <a [href]="this.mgrLink1" target="_blank">{{ mgrLink1 }}</a>
    </div>
    <div
        style="display: flex; flex-direction: column; padding: 1em"
        *ngIf="!!userMsg1 || !!userLink1"
    >
        <div [innerHTML]="userMsg1 | safe: 'html'"></div>
        <a [href]="this.userLink1" target="_blank">{{ userLink1 }}</a>
    </div>

    <ng-template pTemplate="footer">
        <p-checkbox
            [ngModel]="!this.showMsg" (ngModelChange)="this.showMsg = $event"
            [binary]="true"
            (onChange)="dialogCheckboxChangeSubject.next()"
            label="Do not show again (can be turned on in Settings)"
        ></p-checkbox>
    </ng-template>
</p-dialog>
<!-- <div class="mb-1">
    <p-menubar [model]="categoryMenuItems" />
</div> -->
<ef-bizprocess-menu *ngIf="defaultRoleID == 1" [isMainPage]="true"></ef-bizprocess-menu>
<!--if menu bar is present category list height is: height: 81.5vh-->
<div class="category-list">
    <ui-view
        *ngIf="filteredCategories$ | async as categories; else loading"
    >
        <div class="grid">
            <ef-category
                class="col-12 sm:col-6 md:col-4 lg:col-3 col-5"
                *ngFor="let category of filteredCategories$ | async"
                [category]="category"
            ></ef-category>
        </div>
    </ui-view>
</div>

<!-- Reports -->
<!-- <div class="category-list" style="height: 86.3vh; overflow: auto">
    <ui-view
        *ngIf="reports$ | async as reports; else loading"
    >
        <div class="grid">
            <div class="category-group col-12 sm:col-6 md:col-6 lg:col-4 xl:col-3" *ngFor="let reportCategory of reportCategories">
                <div class="mt-3 ml-1 category-header-gradient">
                    <button
                        pButton
                        style="font-weight: 700; font-size: 1.45rem;"
                        type="button"
                        text
                        severity="contrast"
                        class="w-full"
                        [label]="reportCategory.CatDescription"
                    ></button>
                </div>

                <div class="mt-3">
                    <div class="process-list">
                        <div class="grid">
                            <ng-container *ngFor="let report of reports">
                                <div style="position: relative" class="col-12 sm:col-6 md:col-6 lg:col-6 xl:col-6">
                                    <a
                                        href="#"
                                        [target]="report.target ?? '_self'"
                                        rel="noopener"
                                        class="process-link-container"
                                    >
                                        <div
                                            class="process-item process-container p-button-raised w-full"
                                            [title]="report.RptTitle"
                                        >
                                            <div class="process-content">
                                                {{ report.RptTitle }}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ui-view>
</div> -->
